module.exports = __webpack_public_path__ + "img/process.a1471bed.svg";